var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9121 50.8361C40.7172 50.8361 50.2871 41.2661 50.2871 29.4611C50.2871 17.656 40.7172 8.08606 28.9121 8.08606C17.107 8.08606 7.53711 17.656 7.53711 29.4611C7.53711 41.2661 17.107 50.8361 28.9121 50.8361Z",
    stroke: "#6B9D7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1696 34.804C37.2306 36.4281 35.8809 37.7765 34.2559 38.7141C32.631 39.6516 30.788 40.1451 28.912 40.1451C27.036 40.1452 25.193 39.6516 23.568 38.7142C21.943 37.7767 20.5933 36.4282 19.6543 34.8041",
    stroke: "#6B9D7F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8965 27.6798C22.3721 27.6798 23.5684 26.4836 23.5684 25.0079C23.5684 23.5323 22.3721 22.3361 20.8965 22.3361C19.4208 22.3361 18.2246 23.5323 18.2246 25.0079C18.2246 26.4836 19.4208 27.6798 20.8965 27.6798Z",
    fill: "#6B9D7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9277 27.6798C38.4034 27.6798 39.5996 26.4836 39.5996 25.0079C39.5996 23.5323 38.4034 22.3361 36.9277 22.3361C35.4521 22.3361 34.2559 23.5323 34.2559 25.0079C34.2559 26.4836 35.4521 27.6798 36.9277 27.6798Z",
    fill: "#6B9D7F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/Smiley.91af67f1bd86f4be43a26545167730b9.svg";
export { ForwardRef as ReactComponent };